import { useCallback } from 'react';
import { Icon, LockKeyholeIcon, useToastController, View } from 'smoothie';

import { LogoutType } from '../types/auth';

export const useLogoutMessage = () => {
    const toast = useToastController();

    const showLogoutMessage = useCallback((logoutType: LogoutType) => {
        if (logoutType === LogoutType.LogoutButton) {
            toast.show("You've been successfully signed out", {
                icon: (
                    <View
                        backgroundColor="$green300"
                        padding={8}
                        borderRadius={4}
                    >
                        <Icon icon={LockKeyholeIcon} color="$green1100" />
                    </View>
                ),
            });
        }

        if (logoutType === LogoutType.Inactivity) {
            toast.show("You've been signed out due to inactivity", {
                duration: 30 * 60 * 1000, // 30 minutes
                icon: (
                    <View
                        backgroundColor="$green300"
                        padding={8}
                        borderRadius={4}
                    >
                        <Icon icon={LockKeyholeIcon} color="$green1100" />
                    </View>
                ),
            });
        }
    }, []);

    return showLogoutMessage;
};
